import { injectable, inject } from 'inversify';
import { v4 as uuid } from 'uuid';
import config from '@framework/config';
import CookieRepository from '@framework/browser/storage/CookieRepository';
import isServer from '@framework/router/Next/isServer';
import TrackingConsent from '@framework/cookie-consent/TrackingConsent';
import { ConsentCategory } from '@framework/cookie-consent/constants';

@injectable()
class ViewerIdService {
  constructor(
    @inject(CookieRepository) private readonly cookieRepo: CookieRepository,
    @inject(TrackingConsent) private readonly trackingConsent: TrackingConsent,
  ) {}

  getViewerId = async (): Promise<string> => {
    if (isServer()) {
// @ts-ignore TODO: FIN-32798 strictNullChecks
      return null;
    }

    if (!this.trackingConsent.hasConsent(ConsentCategory.Functional)) {
// @ts-ignore TODO: FIN-32798 strictNullChecks
      return null;
    }

    const viewerIdExpires = await this.cookieRepo.get('viewerIdExpires');
// @ts-ignore TODO: FIN-32798 strictNullChecks
    const viewerIdExpiresDate = new Date(viewerIdExpires);
    const now = new Date();
    const timeDiff = viewerIdExpiresDate.getTime() - now.getTime();

    let viewerId = await this.cookieRepo.get('viewerId');
    if (
      !viewerIdExpiresDate || !viewerId
      /*
        * Forces update viewer id if less than 10days of TTl last
        * This is used to protect from viewerId update during view session on page reload.
        * */
      || timeDiff < 10 * 24 * 60 * 60 * 1000
    ) {
      viewerId = uuid();

      const expiresDate = new Date(Date.now() + config.session.viewerIdTtl);
      const cookieOptions = { expires: expiresDate };
      this.cookieRepo.set('viewerId', viewerId, cookieOptions);
      this.cookieRepo.set('viewerIdExpires', expiresDate.toISOString(), cookieOptions);
    }

    return viewerId;
  };
}

export default ViewerIdService;
